import { render, staticRenderFns } from "./distributionCostCalculation.vue?vue&type=template&id=74d2a047&scoped=true"
import script from "./distributionCostCalculation.vue?vue&type=script&lang=js"
export * from "./distributionCostCalculation.vue?vue&type=script&lang=js"
import style0 from "./distributionCostCalculation.vue?vue&type=style&index=0&id=74d2a047&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d2a047",
  null
  
)

export default component.exports